export default __webpack_public_path__ + "static/media/actividad-40b.e5207f1b.mp3";